import Welcome from "../components/PropTest/PropTest";
import AboutMe from "../components/AboutMe/AboutMe";
import { useTranslation } from "react-i18next";

export default function Home(){


    return (
        <>
            <AboutMe/>;
        </>
    );
}